// extracted by mini-css-extract-plugin
export default {"inputContainer":"styled-input_inputContainer__7GPV1","label":"styled-input_label__+f3ZF","input":"styled-input_input__IUQ3Z","transform":"styled-input_transform__DeYbL"};